module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_1@2x.ed4d4952.png";